const customFonts = [
  { label: 'Glora Sans', value: 'Glora Sans' },
  { label: 'Bangers', value: 'Bangers' },
];

export default customFonts;
